import React from 'react';
import { Modal, Button, ButtonGroup, ToggleButton } from "react-bootstrap";
import './Estilos.style.scss'
import COMIDA_IMG from '../images/comida.png';
import HC_IMG from '../images/hueso_carnoso.png';
import CM_IMG from '../images/carne_magra.png';
import PULMON_IMG from '../images/pulmon.png';
import FRUTA_IMG from '../images/fruta.png';
import FLECHA_IMG from '../images/flecha.png';
import WHATSAPP_IMG from '../images/compartir_whatsapp.png';

class ListaCompra extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dias: 7,
        }
    }
    componentDidMount() {
    }
    reiniciarPreguntas() {

    }
    seleccionDias = (event) => {
        if (!isNaN(event.target.value)) {
            this.setState({
                dias: event.target.value,
            })
        }
    }
    _texto() {
        let mensaje = "He hecho calculo de la dieta barf para " + this.state.dias + " dias. Necesitaré: %0a";
        mensaje += this.props.hueso_carnoso * this.state.dias + " de hueso carnoso 🍖. %0a"
        mensaje += this.props.carne * this.state.dias + " de carne magra. 🥩 %0a"
        mensaje += this.props.viscera * this.state.dias + " de viscera. 🫁 %0a"
        mensaje += this.props.fruta_verdura * this.state.dias + " de fruta y verdura 🍎  %0a"
        mensaje += "👽️🐕️ https://www.extraperrestres.com/calculadora/"
        return "https://api.whatsapp.com/send?text=" + mensaje;
    }
    render() {
        const { total, hueso_carnoso, carne, viscera, fruta_verdura } = this.props;
        return (
            <>
                <Modal show={this.props.visible} onHide={() => this.props.ListaVisible(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>¿Que necesito?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Tu perro necesita cada día un total de <strong>{total} gramos </strong>, repartidos en:
                            <strong> {hueso_carnoso} gramos </strong> de hueso carnoso
                            <strong> {carne} gramos </strong> de carne magra
                            <strong> {viscera} gramos </strong> de viscera
                            <strong> {fruta_verdura} gramos </strong> de frutas y verduras</p>
                        <hr />
                        <h5>¿Para cuantos días vas a comprar?</h5>
                        <input value={this.state.dias} onChange={this.seleccionDias} type="range" class="form-range edad" id="selecdyas" min="7" max="180" />
                        <center>

                            <div className="circleBase type3">
                                <input value={this.state.dias} onChange={this.seleccionDias} type="number" id="numberday" class="days" min="7" max="180" />
                                <p>días</p>
                            </div>
                        </center>
                        <div class="container " style={{paddingRight:"20px", paddingTop:"20px"}}>

                            <div class="row">
                                <div class="col big">
                                    <img style={{ width: "30px" }} src={HC_IMG} alt="Logo" />    Hueso carnoso

                                </div>
                                <div class="col small ">
                                    <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" />
                                </div>
                                <div class="col medium" >
                                    <p className="TextEnd"><strong>{hueso_carnoso * this.state.dias}</strong> g</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col big">
                                    <img style={{ width: "30px" }} src={CM_IMG} alt="Logo" />    Carne magra

                                </div>
                                <div class="col small ">
                                    <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" />
                                </div>
                                <div class="col medium" >
                                    <p className="TextEnd"><strong>{carne * this.state.dias}</strong> g</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col big">
                                    <img style={{ width: "30px" }} src={PULMON_IMG} alt="Logo" />   Viscera

                                </div>
                                <div class="col small ">
                                    <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" />
                                </div>
                                <div class="col medium" >
                                    <p className="TextEnd"><strong>{viscera * this.state.dias}</strong> g</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col big">
                                    <img style={{ width: "30px" }} src={FRUTA_IMG} alt="Logo" />   Fruta y verdura

                                </div>
                                <div class="col small ">
                                    <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" />
                                </div>
                                <div class="col medium" >
                                    <p className="TextEnd"><strong>{fruta_verdura * this.state.dias}</strong> g</p>
                                </div>
                            </div>
                            <hr/>
                            <div class="row">
                                <div class="col big">
                                    <img style={{ width: "30px" }} src={COMIDA_IMG} alt="Logo" />  Total

                                </div>
                                <div class="col small ">
                                    <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" />
                                </div>
                                <div class="col medium" >
                                    <p className="TextEnd"><strong>{total * this.state.dias}</strong> g</p>
                                </div>
                            </div>
                        </div>
                        {/* <p><img style={{ width: "30px" }} src={HC_IMG} alt="Logo" /> Hueso carnoso <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" /><strong style={{ textAlign: 'right' }}>{hueso_carnoso * this.state.dias}</strong> g</p>
                        <p><img style={{ width: "30px" }} src={CM_IMG} alt="Logo" /> Carne magra <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" /> <strong style={{ textAlign: 'right' }}>{carne * this.state.dias}</strong> g </p>
                        <p><img style={{ width: "30px" }} src={PULMON_IMG} alt="Logo" /> Vísceras <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" /> <strong style={{ textAlign: 'right' }}>{viscera * this.state.dias}</strong> g</p>
                        <p><img style={{ width: "30px" }} src={FRUTA_IMG} alt="Logo" /> Fruta y verduras <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" /> <strong style={{ textAlign: 'right' }}>{fruta_verdura * this.state.dias}</strong> g</p>
                        <p><img style={{ width: "30px" }} src={COMIDA_IMG} alt="Logo" /> Total <img style={{ width: "20px" }} src={FLECHA_IMG} alt="Logo" /> <strong style={{ textAlign: 'right' }}>{total * this.state.dias}</strong> g </p> */}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.props.ListaVisible(false)}>
                            Cerrar
                        </Button>
                        <a
                            href={this._texto()}
                            className="compartir">
                            Compartir <img style={{ width: "16px", bottom: "3px" }} src={WHATSAPP_IMG} alt="Logo" />
                        </a>


                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}
export default ListaCompra;